import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { LensProductForm } from "@/features/products";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateLensProduct = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (data) => {
    try {
      await apiClient.post("products/bulk/lens", data);
      navigate(-1);
    } catch (error) {
      const errorResponse = error?.response?.data?.meta?.error;
      const errorMessage =
        errorResponse && "products.skuPrefix" in errorResponse
          ? "Terdapat SKU Produk yang sama"
          : getErrorMessage(error, "Gagal membuat produk lensa");

      showSnackbar(errorMessage);
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Produk Lensa"
      breadcrumbs={[
        { title: "Produk Lensa", path: "/inventory/lens-products" },
        { title: "Tambah" },
      ]}
    >
      <LensProductForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
